import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import LiveSignalPill from "@/components/LiveSignalPill";
import IdeaLabPromo from "@/components/IdeaLabPromo";

export default function Solutions() {
  const [solutions, setSolutions] = useState([]);
  useEffect(() => {
    api.get("/solutions").then(({ data }) => setSolutions(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="solutions-page">
      <section className="border-b border-zinc-200">
        <div className="app-container py-24 md:py-32">
          <p className="overline mb-6">Solutions</p>
          <h1 className="text-5xl md:text-6xl font-black tracking-tighter leading-none max-w-4xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Problems first. Software second.
          </h1>
          <p className="text-lg text-zinc-600 mt-6 max-w-2xl">
            Every Appistry build starts with a problem worth naming. If one of these sounds familiar, let's talk it through.
          </p>
        </div>
      </section>

      <section>
        <div className="app-container py-16 md:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border-t border-l border-zinc-200">
            {solutions.map((s, i) => (
              <article
                key={s.id}
                className="p-10 md:p-12 border-r border-b border-zinc-200 bg-white hover:bg-zinc-50 transition-colors flex flex-col md:flex-row gap-8"
                data-testid={`solution-item-${i}`}
              >
                {s.image && (
                  <div className="md:w-2/5 flex-shrink-0 -m-4 md:m-0">
                    <Link to={s.linked_demo_slug ? `/demos/${s.linked_demo_slug}` : "#"} className="block bg-zinc-100 overflow-hidden aspect-[4/3] md:aspect-[5/4] group">
                      <img
                        src={s.image}
                        alt={s.title}
                        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                        loading="lazy"
                        data-testid={`solution-${i}-image`}
                      />
                    </Link>
                  </div>
                )}
                <div className="flex-1">
                  <p className="overline text-zinc-500 mb-4">0{i + 1}</p>
                  <h2 className="text-2xl md:text-3xl font-semibold tracking-tight mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    {s.title}
                  </h2>
                  {s.badge && <div className="mb-4"><LiveSignalPill label={s.badge} testId={`solution-${i}-badge`} /></div>}
                  <p className="text-zinc-700 leading-relaxed mb-4">{s.problem}</p>
                  <div className="hairline my-5" />
                  <p className="text-sm font-mono text-zinc-500 uppercase tracking-widest mb-2">Our approach</p>
                  <p className="text-zinc-600 leading-relaxed mb-6">{s.summary}</p>
                  <div className="flex flex-wrap gap-3">
                    {s.linked_demo_slug && (
                      <Link to={`/demos/${s.linked_demo_slug}`} className="btn-ghost-ink" data-testid={`solution-${i}-demo`}>
                        View the demo <ArrowRight size={14} weight="bold" />
                      </Link>
                    )}
                    <Link to={`/contact?interest=${encodeURIComponent(s.title)}`} className="btn-signal" data-testid={`solution-${i}-enquire`}>
                      Talk to us about this <ArrowRight size={14} weight="bold" />
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <IdeaLabPromo variant="dark" />
    </div>
  );
}
